import "../styles/Socials.css";
import { Twitter, Linkedin, Mail, Github } from "lucide-react";
function Socials() {
  return (
    <div className="container-socials">
      <div className="socials one">
        <a id="social-anchors" href="https://twitter.com/DanielChrost">
          <Twitter size={150} color="white" />
        </a>
        <a
          id="social-anchors"
          href="https://www.linkedin.com/in/daniel-chrostowski/"
        >
          <Linkedin size={150} color="white" />
        </a>
        <a id="social-anchors" href="mailto:dannychrost@gmail.com">
          <Mail size={150} color="white" />
        </a>
        <a id="social-anchors" href="https://github.com/dannychrost">
          <Github size={150} color="white" />
        </a>
        {/*<button id="social-email" onClick="mailto:dannychrost@gmail.com">
          <Mail size={200} color="white" />
        </button>*/}
      </div>
    </div>
  );
}
export default Socials;
